export const getApplyButtonTooltip = (to?: Date, from?: Date) => {
  if (!to && !from) return 'Must select a to and from date'
  if (!to) return 'Must select a to date'
  if (!from) return 'Must select a from date'
  return undefined
}
